import React from 'react'
import { useAuth } from '../auth/AuthContext'
import { Roles } from '../auth/rbac'

// 관점 유형: GA | INSURER | ALL
export function usePerspective() {
  const { hasAnyRole } = useAuth() || { hasAnyRole: () => false }

  const isOperator = hasAnyRole && hasAnyRole([Roles.OPERATOR])
  const isGA = hasAnyRole && hasAnyRole([
    Roles.GA_LEADER,
    Roles.GA_MANAGER,
    Roles.GA_PLANNER,
    Roles.GA_MASTER_ADMIN,
    Roles.GA_MASTER_DEPUTY_ADMIN,
  ])
  const isInsurer = hasAnyRole && hasAnyRole([
    Roles.INSURER_LEADER,
    Roles.INSURER_BRANCH_MANAGER,
    Roles.INSURER_MANAGER,
    Roles.INSURER_PLAN_MANAGER,
  ])

  const storageKey = 'requests.view'

  const deriveDefault = React.useCallback(() => {
    if (isOperator) return 'ALL'
    if (isGA) return 'GA'
    if (isInsurer) return 'INSURER'
    return 'GA'
  }, [isOperator, isGA, isInsurer])

  const [view, setView] = React.useState(() => {
    try {
      const saved = localStorage.getItem(storageKey)
      return saved || deriveDefault()
    } catch {
      return deriveDefault()
    }
  })

  React.useEffect(() => {
    // 역할이 바뀌면 기본값 재평가 (운영자 이탈 등)
    const nextDefault = deriveDefault()
    if (!isOperator && view !== nextDefault) {
      setView(nextDefault)
    }
    // 운영자는 저장된 토글 유지
    // GA/INSURER는 강제 고정
  }, [isOperator, deriveDefault, view])

  const updateView = (next) => {
    const allowed = ['GA', 'INSURER', 'ALL']
    if (!allowed.includes(next)) return
    setView(next)
    try { localStorage.setItem(storageKey, next) } catch {}
  }

  return {
    view,
    setView: updateView,
    isOperator,
    isGA,
    isInsurer,
  }
}


